import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
var AdContainer = function AdContainer(_ref) {
  var viewport = _ref.viewport,
    id = _ref.id,
    pos = _ref.pos,
    page = _ref.page,
    sizes = _ref.sizes,
    mobileSizes = _ref.mobileSizes,
    desktopSizes = _ref.desktopSizes,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    className: "flexible ad-container ".concat(styles.mobileAd),
    "data-ad-container": true,
    "data-ad-viewport": viewport
  }, /*#__PURE__*/React.createElement("div", {
    id: "ad-".concat(id),
    className: "ad-slot",
    "data-ad-selector": "ad-".concat(id),
    "data-ad-position": pos,
    "data-ad-page": page,
    "data-ad-sizes": sizes || '',
    "data-ad-mobile-sizes": mobileSizes || '',
    "data-ad-desktop-sizes": desktopSizes || '',
    style: style
  }));
};
process.env.NODE_ENV !== "production" ? AdContainer.propTypes = {
  viewport: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  pos: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  sizes: PropTypes.string,
  mobileSizes: PropTypes.string,
  desktopSizes: PropTypes.string,
  style: PropTypes.object
} : void 0;
export default AdContainer;